import React, {FC} from 'react';

import {Colors, Text} from '@optimaxdev/design-system';
import {
    Icon,
    CreditCard,
    AmericanExpress,
    ApplePayD,
    Discover,
    Jcb,
    MasterCardD,
    PaypalTransparent,
    VisaD,
    GooglePayD,
    Klarna,
    VenmoWordmark,
    AmazonPay,
} from '@optimaxdev/icons';

import {OrderDetailsPaymentType} from 'types/orderDetailsTypes';

import s from './paymentMethod.scss';

export const PAYMENT_LOGO = {
    'amazon v2': <Icon height="17px" icon={AmazonPay} />,
    'american express': <Icon height="20px" icon={AmericanExpress} />,
    'apple pay': <Icon height="27px" icon={ApplePayD} />,
    'braintree venmo': <Icon color="#008CFF" height="13px" icon={VenmoWordmark} />,
    discover: <Icon height="20px" icon={Discover} />,
    jcb: <Icon height="20px" icon={Jcb} />,
    klarna: <Icon className={s.klarnaIcon} icon={Klarna} />,
    mastercard: <Icon height="20px" icon={MasterCardD} />,
    'pay with interest free installments': <Icon height="20px" icon={MasterCardD} />,
    paypal: <Icon height="15px" icon={PaypalTransparent} />,
    'paypal express': <Icon height="15px" icon={PaypalTransparent} />,
    'paypal express v2 checkout': <Icon height="15px" icon={PaypalTransparent} />,
    'stripe apple pay': <Icon height="27px" icon={ApplePayD} />,
    'stripe google pay': <Icon height="27px" icon={GooglePayD} />,
    visa: <Icon height="20px" icon={VisaD} />,
};

const NOT_APPLICABLE = 'N/A';

type PropsType = {
    payment: OrderDetailsPaymentType;
};

/**
 * Component for order details payment method
 * @returns {JSX.Element} - component
 */
export const PaymentMethod: FC<PropsType> = ({payment}) => {
    const {
        name,
        specific_info: {installments, num, type},
    } = payment;
    const specificType = type === NOT_APPLICABLE ? '' : type;
    const isDesktop = __BUILD_TYPE__ === 'desktop';

    const logo =
        PAYMENT_LOGO[
            (specificType.toLowerCase() || name.toLowerCase()) as keyof typeof PAYMENT_LOGO
        ];

    const choosePaymentText = () => {
        if (installments && num) {
            return (
                <React.Fragment>
                    Ending in {num} <br /> {installments} Installments
                </React.Fragment>
            );
        } else if (specificType && num) {
            const cardName = specificType.toLowerCase();
            return (
                <React.Fragment>
                    <span className={s.cardName}>
                        {cardName === 'mastercard' ? 'master card' : cardName}
                    </span>{' '}
                    - Ending in {num}
                </React.Fragment>
            );
        } else if (logo) {
            return '';
        }
        return name;
    };

    return (
        <div className={s.payment}>
            {logo && <div className={s.icon}>{logo}</div>}
            {specificType && !logo && (
                <div className={s.icon}>
                    <Icon height="20px" icon={CreditCard} />
                </div>
            )}
            <Text
                color={Colors.limedSpruce}
                lineHeight={isDesktop ? '26px' : '130%'}
                size={isDesktop ? '16px' : '14px'}
            >
                {choosePaymentText()}
            </Text>
        </div>
    );
};
